import { useMutation, useQueryClient } from "@tanstack/react-query";
import { frappeMethod } from "@/lib/erp/utils";
import { toast } from "sonner";

/**
 * Archive a document (sets disabled=1).
 * Invalidates item list + detail queries and shows toast.
 * Does NOT navigate — caller's responsibility.
 */
export function useArchiveDoc(doctype: string) {
  const queryClient = useQueryClient();

  return useMutation<
    { success: boolean; message: string },
    Error,
    { name: string }
  >({
    mutationFn: ({ name }) =>
      frappeMethod<{ success: boolean; message: string }>(
        "zaviago_backend.api.archive.archive_doc",
        { doctype, name },
      ),
    onSuccess: (_data, { name }) => {
      if (doctype === "Item") {
        queryClient.invalidateQueries({ queryKey: ["item", name] });
        queryClient.invalidateQueries({ queryKey: ["items", "list"] });
      }
      const dtLower = doctype.toLowerCase().replace(/\s+/g, "-");
      queryClient.invalidateQueries({ queryKey: [dtLower, name] });
      queryClient.invalidateQueries({ queryKey: [dtLower + "s", "list"] });

      queryClient.invalidateQueries({ queryKey: ["archived-count"] });

      const label = doctype === "Item" ? "Product" : doctype;
      toast.success(`${label} archived. Restore anytime.`);
    },
    onError: (error) => {
      toast.error(error.message || "Failed to archive");
    },
  });
}
